import { all } from 'redux-saga/effects';
import {
  watchSMSSendCode,
  watchSmsVerificationCode,
  watchLoginFacebook,
  watchForceLoginByAdmin,
  watchForceLoginByUser,
  watchGetFacebook,
  watchLogoutFacebook,
  watchReActivationReApprove,
  watchReRegister,
  watchSMSSocialAuth,
  watchSocialAuthSmsVerificationCode
} from './authSaga';
import { watchHomeScreen } from './homescreenSaga';
import {
  watchGetMatchData,
  watchGetMatchProfileDetail,
  watchCancelDateByPartner,
  watchParticipateRematch,
  watchCancelForRematch,
  watchAddRequestTimeChange,
  watchUpdateRequestTimeChange,
  watchGetCurrentServerTime
} from './matchSaga';
import {
  watchCancelParticipate,
  watchCancelSampleParticipant,
  watchGetAwaitingParticipantDatingDays,
  watchGetOpenDates,
  watchGetOpenDateStatus,
  watchGetRecommendations,
  watchRequestParticipate,
  watchSetParticipation,
  watchRemoveFirstLoginAfterApprove,
  watchChangeSampleParticipation,
  watchGetUserTrialInfo,
  watchGetMotivateImages,
  watchGetCancelSampleDatingOptions,
  watchRenewExpiredInvoice,
  watchRequestAwaitingCancel,
  watchGetPrefectureAreaMaster,
  watchGetParticipationUserInfo,
  watchGetParticipationWeek,
  watchGetDatingNeedFeedback
} from './participationSaga';
import { watchGetPopupsData, watchDeletePopupData } from './popupsSaga';
import {
  watchGetPlanSubscription,
  watchGetUserProfile,
  watchGetPreferencesInfo,
  watchUpdatePreferences,
  watchUpdateProfileInfo
} from './userProfileSaga';
import { watchUseCoupon } from './useCouponSaga';
import { watchCancelDate, watchGetCancelDatingOptions } from './cancelDateSaga';
import {
  watchUpdateEmail,
  watchStopReceiveNotifications,
  watchGetStopReceiveNotifications
} from './updateEmailSaga';
import {
  watchGetUserGlobalInfo,
  watchGetCancelDeactiveOptions
} from './userGlobalInforSaga';
import { watchChatRoom, watchGetTwilioToken } from './chatRoomSaga';
import { watchChatHistory, watchUpdateCursor } from './chatHistorySaga';
import { watchGetCafe } from './cafeSaga';
import { watchGetChatMessages } from './chatMessagesSaga';
import {
  watchDeactiveProfile,
  watchCancelCommitOption,
  watchValidateDeactivateProfile
} from './deactiveProfileSaga';
import {
  watchCancelChangeCostPlan,
  watchChangeCostPlan
} from './changePlanSaga';
import { watchCancelProfile } from './cancelProfileSaga';
import {
  watchSaveUserFeedback,
  watchGetUserFeedbackDetails,
  watchCheckSendFeedback,
  watchGetAvailableFeedbackFlexQuestions,
  watchGetAvailableFeedbackFixedQuestions
} from './feedbackSaga';
import { watchGetInviteFriendsData } from './inviteFriendsSaga';
import { watchGetMatchProfileInfoData } from './getMatchProfileInfoSaga';
import { watchGetEvaluationInfoData } from './getEvaluationInfoSaga';
import { watchGetEvaluationListData } from './getEvaluationListSaga';
import {
  watchGetCouponsData,
  watchExchangeCouponsData,
  watchApplyCoupon,
  watchRetrieveUserCoupon,
  watchPurchaseCoupon,
  watchGetCouponPackages
} from './couponsSaga';
import { watchRematch } from './rematchSaga';
import { watchUseImage } from './userImageSagas';
import { watchValidateSelecting } from './validateSelectingSaga';
import {
  watchGetStepOne,
  watchGetStepTwo,
  watchGetStepThree,
  watchGetStepFour,
  watchGetStepFive,
  watchGetStepSix,
  watchPostStepOne,
  watchPostStepTwo,
  watchPostStepThree,
  watchPostStepFour,
  watchPostStepFive,
  watchPostStepSix,
  watchPostStepSeven,
  watchPostStepSevenFive,
  watchGetStepSeven,
  watchGetStepSevenFive,
  watchGetStepEight,
  watchPostStepEight,
  watchGetStepOnePointFive,
  watchPostStepOnePointFive,
  watchPostSpecificStepZero,
  watchGetStepUrl
} from './registationFormSaga';

import {
  watchGetStepOne as watchGetStepOne2nd,
  watchGetStepTwo as watchGetStepTwo2nd,
  watchGetStepThree as watchGetStepThree2nd,
  watchGetStepFour as watchGetStepFour2nd,
  watchGetStepFive as watchGetStepFive2nd,
  watchGetStepSix as watchGetStepSix2nd,
  watchPostStepOne as watchPostStepOne2nd,
  watchPostStepTwo as watchPostStepTwo2nd,
  watchPostStepThree as watchPostStepThree2nd,
  watchPostStepFour as watchPostStepFour2nd,
  watchPostStepFive as watchPostStepFive2nd,
  watchPostStepSix as watchPostStepSix2nd,
  watchPostStepSeven as watchPostStepSeven2nd,
  watchGetStepSeven as watchGetStepSeven2nd,
  watchGetStepEight as watchGetStepEight2nd,
  watchPostStepEight as watchPostStepEight2nd,
  watchPostStepSixPointFive,
  watchGetStepSixPointFive,
  watchUpdateFirstAccessStepOne2nd,
  watchUpdatePrefectureAndArea,
  watchGetPrefectureAndArea
} from './2ndRegistrationFormSaga';
import {
  watchCreateCard,
  watchGetCards,
  watchCreateSetupIntent,
  watchCheckSetupIntentCompleted,
  watchSetDefaultCard
} from './cardsSaga';
import {
  watchGetMyPageInfoSaga,
  watchGetBannerSlideData
} from './myPageInfoSaga';
import { watchGetDatingDayAbleToChat } from './datingDayAbleToChatSaga';
import {
  watchGetPlan,
  watchChangeUserPlan,
  watchValidateBeforeChangeUserPlan,
  watchGetScheduledPlan
} from './userPlanSaga';
import { watchAccessChatRoom } from './chatRoomSaga';
import {
  watchChangeDatingStatus,
  watchChangeMultipleDatingStatus
} from './datingStatusSaga';
import { watchUpdateTempCancelTrial } from './tempCancelTrialSaga';
import { watchGetUserInfoFacebookPixel } from './userInfoFacebookPixelSaga';
import { watchSendNoticeException } from './exceptionSaga';
import {
  watchSubscriptionPausedRequest,
  watchCancelSubscriptionPauseRequest,
  watchGetSubscriptionPauseInfoForCancel
} from './subscriptionPausedSaga';
import { watchUpdateUserMotivatedDating } from './userMotivatedDatingSaga';
import { watchParticipateCommitOptionSaga } from './commitOptionSaga';
import { watchSaveFeedbackCommitOption } from './feedbackCommitOptionSaga';
import { watchGetUserNeedToUpdateNewPreferences } from './userPreferencesSaga';
import {
  watchUpdateReadStatusForNoticePopup,
  watchGetNoticePopup
} from './noticePopupSaga';
import {
  watchGetUserCertification,
  watchUpdateUserCertification,
  watchStoreImageUserCertification
} from './userCertificationSaga';
import { watchDownloadBannerSaga } from './downloadBannerSaga';
import { watchShowNewChatDesign } from './showNewChatDesignSaga';
import {
  watchGetUserRankInfo,
  watchRequestUpRank,
  watchRequestRemainRank,
  watchApprovedOrRejectedRank
} from './userRankSaga';
import { watchGetEmailReservation } from './emailReservationSage';
import {
  watchUpdateStepTwoFaceType,
  watchUpdateFaceTypeStepOne,
  watchGetFaceType
} from './faceTypeSaga';
import {
  watchGetUserParticipationItems,
  watchPurchaseDatingItems,
  watchGetUserOwnedParticipationItems,
  watchUpdateUserParticipationItemsStatus
} from './userParticipationItems';

export default function* rootSaga() {
  yield all([
    watchSMSSendCode(),
    watchSMSSocialAuth(),
    watchSmsVerificationCode(),
    watchSocialAuthSmsVerificationCode(),
    watchLoginFacebook(),
    watchForceLoginByAdmin(),
    watchForceLoginByUser(),
    watchLogoutFacebook(),
    watchGetFacebook(),
    watchHomeScreen(),
    watchGetMatchData(),
    watchUpdateRequestTimeChange(),
    watchAddRequestTimeChange(),
    watchSetParticipation(),
    watchGetPopupsData(),
    watchDeletePopupData(),
    watchUseCoupon(),
    watchCancelDate(),
    watchGetCancelDatingOptions(),
    watchGetCancelSampleDatingOptions(),
    watchUpdateEmail(),
    watchStopReceiveNotifications(),
    watchGetStopReceiveNotifications(),
    watchGetUserGlobalInfo(),
    watchGetCancelDeactiveOptions(),
    watchCancelDateByPartner(),
    watchParticipateRematch(),
    watchCancelForRematch(),
    watchChatRoom(),
    watchGetTwilioToken(),
    watchChatHistory(),
    watchUpdateCursor(),
    watchGetCafe(),
    watchGetChatMessages(),
    watchCancelChangeCostPlan(),
    watchChangeCostPlan(),
    watchDeactiveProfile(),
    watchCancelCommitOption(),
    watchValidateDeactivateProfile(),
    watchCancelProfile(),
    watchSaveUserFeedback(),
    watchGetUserFeedbackDetails(),
    watchGetInviteFriendsData(),
    watchGetMatchProfileInfoData(),
    watchGetCouponsData(),
    watchExchangeCouponsData(),
    watchGetCouponPackages(),
    watchRematch(),
    watchGetEvaluationInfoData(),
    watchGetEvaluationListData(),
    watchCheckSendFeedback(),
    watchGetCurrentServerTime(),
    watchSaveFeedbackCommitOption(),
    watchGetAvailableFeedbackFlexQuestions(),
    watchGetAvailableFeedbackFixedQuestions(),

    //PARTICIPATION
    watchGetOpenDates(),
    watchGetParticipationUserInfo(),
    watchGetParticipationWeek(),
    watchGetDatingNeedFeedback(),
    watchRequestParticipate(),
    watchCancelParticipate(),
    watchRequestAwaitingCancel(),
    watchCancelSampleParticipant(),
    watchGetRecommendations(),
    watchGetAwaitingParticipantDatingDays(),
    watchGetOpenDateStatus(),
    watchRemoveFirstLoginAfterApprove(),
    watchChangeSampleParticipation(),
    watchGetMotivateImages(),
    watchGetUserTrialInfo(),
    watchRenewExpiredInvoice(),
    watchGetPrefectureAreaMaster(),

    //COUPONS
    watchApplyCoupon(),
    watchRetrieveUserCoupon(),
    watchPurchaseCoupon(),

    //registration form
    watchGetStepUrl(),
    watchGetStepOne(),
    watchGetStepTwo(),
    watchGetStepThree(),
    watchGetStepFour(),
    watchGetStepFive(),
    watchGetStepSix(),
    watchGetStepSixPointFive(),
    watchGetStepSeven(),
    watchGetStepSevenFive(),
    watchGetStepEight(),
    watchGetStepOnePointFive(),
    watchPostStepOne(),
    watchPostStepTwo(),
    watchPostStepThree(),
    watchPostStepFour(),
    watchPostStepFive(),
    watchPostStepSix(),
    watchPostStepSixPointFive(),
    watchPostStepSeven(),
    watchPostStepSevenFive(),
    watchPostStepEight(),
    watchPostStepOnePointFive(),
    watchPostSpecificStepZero(),

    //2nd registration form
    watchGetStepOne2nd(),
    watchUpdateFirstAccessStepOne2nd(),
    watchGetStepTwo2nd(),
    watchGetStepThree2nd(),
    watchGetStepFour2nd(),
    watchGetStepFive2nd(),
    watchGetStepSix2nd(),
    watchGetStepSeven2nd(),
    watchPostStepOne2nd(),
    watchPostStepTwo2nd(),
    watchPostStepThree2nd(),
    watchPostStepFour2nd(),
    watchPostStepFive2nd(),
    watchPostStepSix2nd(),
    watchPostStepSeven2nd(),
    watchGetStepEight2nd(),
    watchPostStepEight2nd(),
    watchUpdatePrefectureAndArea(),
    watchGetPrefectureAndArea(),

    watchReActivationReApprove(),
    watchReRegister(),
    watchGetMatchProfileDetail(),
    //User profile & preferences
    watchGetPlanSubscription(),
    watchGetPreferencesInfo(),
    watchUpdatePreferences(),
    watchGetUserProfile(),
    watchUpdateProfileInfo(),
    watchGetMyPageInfoSaga(),
    watchUseImage(),
    watchGetBannerSlideData(),
    //Cards
    watchGetCards(),
    watchCreateCard(),
    watchCreateSetupIntent(),
    watchCheckSetupIntentCompleted(),
    watchSetDefaultCard(),
    //Dating Day able to chat
    watchGetDatingDayAbleToChat(),
    //Plans
    watchGetPlan(),
    watchChangeUserPlan(),
    watchValidateBeforeChangeUserPlan(),
    watchGetScheduledPlan(),

    //Access chat room
    watchAccessChatRoom(),

    watchChangeDatingStatus(),
    watchChangeMultipleDatingStatus(),
    watchUpdateTempCancelTrial(),

    // get user info for fb pixel
    watchGetUserInfoFacebookPixel(),
    // Validate Selecting date
    watchValidateSelecting(),
    // send notice exception
    watchSendNoticeException(),

    //send request subscription paused
    watchSubscriptionPausedRequest(),
    watchCancelSubscriptionPauseRequest(),
    watchGetSubscriptionPauseInfoForCancel(),

    //user motivated dating
    watchUpdateUserMotivatedDating(),
    //commit option golden week
    watchParticipateCommitOptionSaga(),

    //check user need to update new preferences
    watchGetUserNeedToUpdateNewPreferences(),
    //update read status notice status
    watchUpdateReadStatusForNoticePopup(),
    watchGetNoticePopup(),

    //User certification
    watchGetUserCertification(),
    watchUpdateUserCertification(),
    watchStoreImageUserCertification(),

    //Downlaod app banner
    watchDownloadBannerSaga(),

    // New chat design
    watchShowNewChatDesign(),

    //user rank
    watchGetUserRankInfo(),
    watchRequestUpRank(),
    watchRequestRemainRank(),
    watchApprovedOrRejectedRank(),

    // Email Reservation
    watchGetEmailReservation(),

    //FACE TYPE
    watchGetFaceType(),
    watchUpdateStepTwoFaceType(),
    watchUpdateFaceTypeStepOne(),

    //USER PARTICIPATION ITEMS
    watchGetUserParticipationItems(),
    watchPurchaseDatingItems(),
    watchGetUserOwnedParticipationItems(),
    watchUpdateUserParticipationItemsStatus(),
  ]);
}
